import React, { useState, useEffect } from 'react';
import SelectConversation from './SelectConversation';
import Loader from './Loader';
import CallScoreReport from './CallScoreReport';
import ProgressBar from '../CallScore/ProgressBar/ProgressBar'

import {retrieveCallScore, fetchCallScore, fetchJobStatus, getSymblAccessToken, fetchTranscriptMessages, fetchAttendees, generateCallScoreViaTextApi, generateCallScoreViaAudioApi, generateCallScoreForExistingConversation} from "../../services/callScore";
import { formatTranscriptMessages } from "../../utils";

const CallScore = () => {
  const [step, setStep] = useState('select'); // 'select' | 'loading' | 'report'
  const [progressStep, setProgressStep] = useState(0);
  const [selectedType, setSelectedType] = useState(null);
  const [callScoreData, setCallScoreData] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState(null);
  const [transcriptMessages, setTranscriptMessages] = useState([]);
  const [attendeesIdsWithIndex, setAttendeesIdsWithIndex] = useState(null);
  const [accessToken, setAccessToken] = useState(null);



  const handleGenerate = async () => {
    if (!selectedType) return;
    setStep('loading');
    setJobStatus('creating_conversation');
    
    try {
      // const token = await getSymblAccessToken();
      // setAccessToken(token);

      // const response = await generateCallScoreViaTextApi(selectedType.data);
      // const response = await generateCallScoreForExistingConversation(selectedType.conversationId);
      setConversationId(selectedType.conversationId);
      
      const randomWaitTime = Math.floor(Math.random() * 1000) + 500;
      await new Promise(resolve => setTimeout(resolve, randomWaitTime));
      
      // Start polling for status updates
      // const pollStatus = async () => {
      //   const statusData = await fetchJobStatus(response.conversationId);
      //   setJobStatus(statusData.status);

      //   if (statusData.status === 'completed') {
          // Retrieve callscore data
          const callScoreData = await retrieveCallScore(selectedType.conversationId);
          // const callScoreData = await fetchCallScore(selectedType.conversationId);
          
          // Retrieve transcript messages 
          // const { messages = [] } = await fetchTranscriptMessages(response.conversationId);
          // const formattedMessages = formatTranscriptMessages(messages);
          
          // Retrieve transcript attendees
          // const { members = [] } = await fetchAttendees(response.conversationId);
          // const membersIdsWithIndex = members?.reduce((attendeeIdsWithIndex, {id}, index) => (
          //   {...attendeeIdsWithIndex, [id]: index}
          // ), {});

          setCallScoreData(callScoreData);
          // setTranscriptMessages(formattedMessages);
          // setAttendeesIdsWithIndex(membersIdsWithIndex);
          setStep('report');
          return true; // Signal completion
      //   }
      //   return false;
      // };

      // // Initial status check
      // const isCompleted = await pollStatus();
      // if (!isCompleted) {
      //   // Start polling every 5 seconds if not completed
      //   const interval = setInterval(async () => {
      //     const isCompleted = await pollStatus();
      //     if (isCompleted) {
      //       clearInterval(interval);
      //     }
      //   }, 2500);
      // }
    } catch (error) {
      console.error('Error generating call score:', error);
      // You might want to add error handling state and UI
    }
  };

  const handleTryAnother = () => {
    setStep('select');
    setSelectedType(null);
    setCallScoreData(null);
  };

  useEffect(() => {
    if (jobStatus === 'creating_conversation') {
      setProgressStep(0);
    } else if (jobStatus === 'in_progress') {
      setProgressStep(1);
    } else if (jobStatus === 'processing') {
      setProgressStep(2);
    } else if (jobStatus === 'completed') {
      setProgressStep(3);
    }
}, [jobStatus]);

  // useEffect(() => {
  //   if (!conversationId || !jobId || step !== 'loading') return;

  //   const fetchStatus = async () => {
  //     try {
  //       const statusData = await fetchJobStatus(conversationId);
  //       setJobStatus(statusData.status);

  //       if (statusData.status === 'completed') {
  //         const callScoreData = await retrieveCallScore(conversationId);
  //         const { messages = [] } = await fetchTranscriptMessages(conversationId);
  //         const { members = [] } = await fetchAttendees(conversationId);
          
  //         // Update all necessary state
  //         setCallScoreData(callScoreData);
  //         setTranscriptMessages(formatTranscriptMessages(messages));
  //         setAttendeesIdsWithIndex(members?.reduce((acc, {id}, index) => ({...acc, [id]: index}), {}));
  //         setStep('report');
  //       }
  //     } catch (error) {
  //       console.error('Error fetching status:', error);
  //     }
  //   };

  //   fetchStatus();
  //   const interval = setInterval(fetchStatus, 10000); // Poll every 10 seconds

  //   return () => clearInterval(interval);
  // }, [conversationId, jobId, step]);

  const renderStep = () => {
    switch (step) {
      case 'loading':
        return <div>
            {/* <ProgressBar step={progressStep} isSymblDemo={true} /> */}
            <h2>Generating Call Score...</h2>
            <Loader />
        </div>;
      case 'report':
        return callScoreData ? (
          <CallScoreReport callScoreResponse={callScoreData} messages={transcriptMessages} attendeesIdsWithIndex={attendeesIdsWithIndex} hideTranscript={true} onTryAnother={handleTryAnother} />
        ) : null;
      default:
        return (
          <SelectConversation
            selectedType={selectedType}
            onTypeSelect={setSelectedType}
            onGenerate={handleGenerate}
          />
        );
    }
  };

  return (
    <div style={{ ...styles['callscore-container'], ...(step === 'loading' ? {width: '100%'} : {}), ...(step === 'select' ? {border: 'none'} : {})}}>
      {renderStep()}
    </div>
  );
};

const styles = {
  'callscore-container': {
    maxWidth: '600px',
    margin: '24px auto',
    padding: '16px',
    // border: '1px solid #E2E8F0',
    // borderRadius: '16px',
  },
};

export default CallScore;

